import { combineReducers } from "redux";
import layout from "./layout";
import cart from "./cart";
import profile from "./profile";
import config from "./config";
import app from "./app";

export default combineReducers({ layout, cart, profile, config, app });
